/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * MSAPP - A multi-student application fee discount is applied when more than one student in a family is enrolled in a program. DRCTR - discount code used for director discounts like scholarships.
 * @export
 * @enum {string}
 */
export enum TuitionInvoiceDiscountCode {
  Msapp = 'MSAPP',
  Drctr = 'DRCTR',
}

export function TuitionInvoiceDiscountCodeFromJSON(
  json: any
): TuitionInvoiceDiscountCode {
  return TuitionInvoiceDiscountCodeFromJSONTyped(json, false)
}

export function TuitionInvoiceDiscountCodeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TuitionInvoiceDiscountCode {
  return json as TuitionInvoiceDiscountCode
}

export function TuitionInvoiceDiscountCodeToJSON(
  value?: TuitionInvoiceDiscountCode | null
): any {
  return value as any
}
